import FormLinks from '@components/search/forms/FormLinksCustom'
import FormLinkCustom from '@components/search/forms/FormLinkCustom'

import styles from 'styles/FormLinkTile.module.css'

const FormLinksRadio = (props) =>
    <FormLinks {...props}
        LinkItem={FormLinkCustom}
        styles={styles} />

export default FormLinksRadio